import { render, staticRenderFns } from "./undeveloped.vue?vue&type=template&id=30141af0&scoped=true"
var script = {}
import style0 from "./undeveloped.vue?vue&type=style&index=0&id=30141af0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.11_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30141af0",
  null
  
)

export default component.exports